import React, { useEffect, useState } from "react";
import { Reveal, SectionHeader } from "@/components/ui-blocks/Reveal";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { api, endpoints } from "@/lib/api";
import { Quote } from "lucide-react";

export const TestimonialsCarousel = () => {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get(endpoints.testimonials).then(setItems).catch(() => {}); }, []);
  return (
    <section className="bg-background">
      <div className="container-wide py-16 lg:py-24">
        <SectionHeader eyebrow="Testimonials" title="Voices from our community." lead="Volunteers, donors, beneficiaries and partners — on why they choose CAF." />
        <Carousel opts={{ align: "start", loop: true }}>
          <CarouselContent>
            {items.map((t, i) => (
              <CarouselItem key={t.id} className="md:basis-1/2 lg:basis-1/3">
                <Reveal delay={i * 0.05}>
                  <div className="h-full rounded-xl border border-[hsl(var(--border))] p-6 bg-card flex flex-col" data-testid={`testimonial-${t.id}`}>
                    <Quote className="h-6 w-6 text-[hsl(var(--orange))]" />
                    <p className="mt-3 text-[hsl(var(--ink))] leading-relaxed">“{t.quote}”</p>
                    <div className="mt-6 flex items-center gap-3">
                      <img src={t.image} loading="lazy" alt={t.name} className="h-11 w-11 rounded-full object-cover" />
                      <div>
                        <div className="font-semibold text-[hsl(var(--navy))]">{t.name}</div>
                        <div className="text-xs text-[hsl(var(--muted-ink))]">{t.role}</div>
                      </div>
                    </div>
                  </div>
                </Reveal>
              </CarouselItem>
            ))}
          </CarouselContent>
          <div className="hidden md:flex"><CarouselPrevious /><CarouselNext /></div>
        </Carousel>
      </div>
    </section>
  );
};
